export default {
  title: 'Technical error',
  message: 'A technical error has occurred. We are sorry for any inconvenience this may cause you.',
  technicalErrorButton: 'Retry',
};
